import { BaseDto } from '@greco/util-dto';
export class CreateStationsDto extends BaseDto {
  communityId: string;
  title: string;
}
